import axios from 'axios';
import { BASE_URL } from '../constants/urlsConstants';
import { LS_CSRF_TOKEN_KEY } from '../constants/storagesKeysConstants';
import { getCookie } from '../utils/utilsOld';

const request = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
});

request.interceptors.request.use((config) => {
    const csrfToken =
        process.env.NODE_ENV === 'development' ? localStorage.getItem(LS_CSRF_TOKEN_KEY) : getCookie('csrftoken');

    // Add only for 'dangerous' methods
    const safeMethods = ['get', 'head', 'options'];
    if (config.method && !safeMethods.includes(config.method.toLowerCase()) && csrfToken) {
        config.headers['X-CSRFToken'] = csrfToken;
    }

    return config;
});

export default request;
